import Vue from 'vue';

Vue.filter('Locale', (value) => {
    if (!value) return '';
    switch (value) {
        case 'pt-BR':
            return 'Português';
        case 'es-ES':
            return 'Espanhol';
        default:
            return 'Inglês';
    }
});
